import React, {
  useLayoutEffect,
  useState,
  useEffect,
  useRef,
  memo,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { getRequestParams } from "../../helpers/globalfunctions.js";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { Template } from "devextreme-react/core/template";
import Modal from "react-modal";
import { axiosGet, axiosPost } from "../../apis/useAxios.js";
import { DropDownBox, List, LoadPanel } from "devextreme-react";
import { RegEx } from "../../helpers/fixcodes.js";
import DataSource from "devextreme/data/data_source";
import {
  askConfirmation,
  showResponseMessageWithErrorInToast,
} from "../../helpers/message.js";
import Map from "devextreme-react/map";
import GooglePlaceSearchComponent from "../Shared/GooglePlaceSearchComponent.jsx";
import { DataGridSkeletonPageSimpleWithTitle } from "../skeleton/GridSkeleton.js";
import UserActivityHistoryComponent from "../Shared/UserActivityHistoryComponent.jsx";

export default function HotelsComponent() {
  const [state, setState] = useState({
    isHotelApiLoading: false,
    hotelGridDataSource: null,
    isSaveHotelModalOpen: false,
    rowData: null,
    isView: false,
    historyModal: {
      openModal: false,
      airlineCode: "",
      hotelCode: "",
      displayTitle: "",
    },
  });
  const refDataGrid = useRef(null);
  useLayoutEffect(() => {
    document.querySelector("#lblPageTitle").innerHTML = `Hotels`;
  });

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchGridDataOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchGridDataOnPageLoad = () => {
    try {
      setTimeout(async () => {
        setState((prev) => ({
          ...prev,
          isHotelApiLoading: true,
        }));
        await getServiceHotelList();
        setState((prev) => ({
          ...prev,
          isHotelApiLoading: false,
        }));
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };

  const getServiceHotelList = async () => {
    try {
      const response = await axiosGet(`/Hotel/get-hotels`, {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
      });
      setState((prev) => ({
        ...prev,
        hotelGridDataSource: response?.payload ?? [],
      }));
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          {state.isHotelApiLoading && <DataGridSkeletonPageSimpleWithTitle />}
          {!state.isHotelApiLoading && (
            <DataGrid
              ref={refDataGrid}
              dataSource={state.hotelGridDataSource}
              showBorders={true}
              columnAutoWidth={true}
              allowColumnResizing={true}
              showRowLines={true}
              showColumnLines={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "after",
                    template: "toolbarTemplateAddHotel",
                  },
                  {
                    location: "after",
                    widget: "dxButton",
                    options: {
                      icon: "refresh",
                      onClick: async (e) => {
                        try {
                          refDataGrid.current.instance.beginCustomLoading();
                          e.component.option("icon", "fas fa-spinner fa-spin");
                          await new Promise((resolve) =>
                            setTimeout(resolve, 500)
                          ); // 0.5 sec
                          await getServiceHotelList();
                          refDataGrid.current.instance.endCustomLoading();
                          e.component.option("icon", "refresh");
                        } catch (error) {
                          console.log(error);
                        }
                      },
                    },
                  }
                );
              }}
            >
              <Column
                dataField="id"
                caption=""
                allowSorting={false}
                allowSearch={false}
                allowExporting={false}
                allowFiltering={false}
                fixed={true}
                width={"auto"}
                cellRender={(data) => {
                  return (
                    <>
                      <a
                        href="#"
                        title="Update"
                        onClick={(e) => {
                          e.preventDefault();
                          setState((prev) => ({
                            ...prev,
                            isSaveHotelModalOpen: true,
                            rowData: data.data,
                          }));
                        }}
                        className="btn-link"
                      >
                        <i
                          style={{ cursor: "pointer", marginLeft: "6px" }}
                          className="fas fa-edit"
                        />
                      </a>
                      <a
                        href="#"
                        title="View"
                        onClick={(e) => {
                          debugger;
                          e.preventDefault();
                          setState((prev) => ({
                            ...prev,
                            isSaveHotelModalOpen: true,
                            rowData: data.data,
                            isView: true,
                          }));
                        }}
                        className="btn-link"
                      >
                        <i
                          style={{ cursor: "pointer", marginLeft: "6px" }}
                          className="fas fa-eye"
                        />
                      </a>
                      <a
                        href="#"
                        title="Log"
                        onClick={(e) => {
                          debugger;
                          e.preventDefault();
                          setState((prev) => ({
                            ...prev,
                            historyModal: {
                              openModal: true,
                              airlineCode: data.data.airlineCode,
                              hotelCode: data.data.code,
                              displayTitle: data.data.name,
                            },
                          }));
                        }}
                        className="btn-link"
                      >
                        <i
                          style={{ cursor: "pointer", marginLeft: "6px" }}
                          className="fas fa-exclamation-circle"
                        />
                      </a>
                    </>
                  );
                }}
              />
              <Column
                dataField="airportCode"
                caption="Airport"
                allowSearch={true}
              />
              <Column
                dataField="code"
                caption="Hotel Code"
                allowSearch={true}
              />
              <Column
                dataField="name"
                caption="Hotel Name"
                allowSearch={true}
              />
              <Column
                dataField="contactNumber"
                caption="Contact Number"
                allowSearch={true}
              />
              <Column
                dataField="streetNumber"
                caption="Street Number"
                allowSearch={true}
              />
              <Column
                dataField="streetName"
                caption="Street Name"
                allowSearch={true}
              />
              <Column dataField="city" caption="City" allowSearch={true} />
              <Column dataField="state" caption="State" allowSearch={true} />
              <Column
                dataField="latitude"
                caption="Latitude"
                allowSearch={true}
              />
              <Column
                dataField="longitude"
                caption="Longitude"
                allowSearch={true}
              />
              <Column
                dataField="address"
                caption="Address"
                allowSearch={true}
              />
              <Column
                dataField="postalCode"
                caption="Postal Code"
                allowSearch={true}
              />
              <Template
                name="toolbarTemplateAddHotel"
                render={() => {
                  return (
                    <>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={() => {
                          setState((prev) => ({
                            ...prev,
                            isSaveHotelModalOpen: true,
                          }));
                        }}
                      >
                        <span title="Submit">
                          <i className="fas fa-plus"></i>&nbsp;Add Hotel
                        </span>
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={true} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={20} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 50]}
                showInfo={true}
                visible={true}
              />
              <Export
                enabled={true}
                allowExportSelectedData={false}
                fileName="Hotels"
              />
            </DataGrid>
          )}
        </div>
      </div>

      {state.isSaveHotelModalOpen && (
        <SaveHotelComponent
          rowData={state.rowData}
          isView={state.isView}
          onRefresh={async () => {
            await getServiceHotelList();
          }}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              isSaveHotelModalOpen: false,
              rowData: null,
              isView: false,
            }));
          }}
        />
      )}
      {state.historyModal.openModal && (
        <UserActivityHistoryComponent
          airlineCode={state.historyModal.airlineCode}
          displayTitle={state.historyModal.displayTitle}
          columnValue1={state.historyModal.hotelCode}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              historyModal: {
                openModal: false,
                airlineCode: "",
                displayTitle: "",
                hotelCode: "",
              },
            }));
          }}
        />
      )}
    </>
  );
}

const SaveHotelComponent = memo((props) => {
  const [mappedAirportCodes, setMappedAirportCodes] = useState([]);
  const [state, setState] = useState({
    isSubmitted: false,
    loadPanelVisible: false,
    openGooglePlaceSearchModal: false,
    dropdownAirportDataSource: [],
    airlineCode: props?.rowData?.airlineCode ?? "",
    hotelCode: props?.rowData?.code ?? "",
    hotelName: props?.rowData?.name ?? "",
    streetName: props?.rowData?.streetName ?? "",
    streetNumber: props?.rowData?.streetNumber ?? "",
    contactNumber: props?.rowData?.contactNumber ?? "",
    email: props?.rowData?.email ?? "",
    city: props?.rowData?.city ?? "",
    state: props?.rowData?.state ?? "",
    country: props?.rowData?.country ?? "",
    latitude: props?.rowData?.latitude ?? "",
    longitude: props?.rowData?.longitude ?? "",
    postalCode: props?.rowData?.postalCode ?? "",
    errors: {
      hotelCode: "",
      hotelName: "",
      streetName: "",
      streetNumber: "",
      contactNumber: "",
      email: "",
      city: "",
      state: "",
      country: "",
      postalCode: "",
      latitude: "",
      longitude: "",
      airportCode: "",
    },
  });
  const refLstAirport = useRef(null);
  const getDropdownAirportDataSource = async () => {
    let airportCodeDropdownLst = [];
    try {
      let url = `${
        process.env.REACT_APP_API_BASE_URL
      }Airport/get-airport-dropdown/${sessionStorage.getItem(
        "session_airlineCode"
      )}`;
      const res = await fetch(url, getRequestParams("GET")).then((response) =>
        response.json()
      );
      airportCodeDropdownLst = [...new Set(res.payload ?? [])];
    } catch (error) {
      console.log(error);
    }
    return airportCodeDropdownLst;
  };

  const fetchApiOnPageLoad = async () => {
    try {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: true,
      }));
      let airportCodeDropdownLst = await getDropdownAirportDataSource();
      let mappedAirportCodes = [];
      if (props.rowData?.mappedAirportCodes) {
        mappedAirportCodes = [
          ...new Set(
            props.rowData.mappedAirportCodes.map((code) => code.trim())
          ),
        ];
      }

      let mappedAirportCodeLst = [
        ...new Set(
          mappedAirportCodes.map((code) => {
            return {
              airportCode: code.trim(),
              airportName:
                airportCodeDropdownLst.filter(
                  (el) => el.airportCode.trim() === code.trim()
                )?.[0]?.airportName ?? "",
              isMapped: 1,
            };
          })
        ),
      ];
      let unMappedAirportCodeLst = [
        ...new Set(
          airportCodeDropdownLst
            .filter((el) => {
              return !mappedAirportCodes.find((code) => {
                return code.trim() === el.airportCode.trim();
              });
            })
            .map((item) => ({
              ...item,
              isMapped: 0,
            }))
        ),
      ];
      let airportCodeDropdown = [
        ...mappedAirportCodeLst,
        ...unMappedAirportCodeLst,
      ];
      setMappedAirportCodes(mappedAirportCodes);
      setState((prev) => ({
        ...prev,
        dropdownAirportDataSource: airportCodeDropdown,
      }));
      setTimeout(() => {
        if (refLstAirport?.current?.instance) {
          refLstAirport.current.instance.option(
            "selectedItemKeys",
            mappedAirportCodes
          );
        }
      }, 500);
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
      }));
    }
  };
  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    let err = state.errors;
    switch (name) {
      case "hotelCode":
        err.hotelCode = "";
        if (value.trim() === "" || value.length <= 8) {
          setState((prev) => ({ ...prev, hotelCode: value }));
        }
        break;
      case "hotelName":
        err.hotelName = "";
        if (value.trim() === "" || value.length <= 60) {
          setState((prev) => ({ ...prev, hotelName: value }));
        }
        break;
      case "streetNumber":
        err.streetNumber = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, streetNumber: value }));
        }
        break;
      case "latitude":
        err.latitude = "";
        if (value.trim() === "" || RegEx.LatLong.test(value)) {
          setState((prev) => ({ ...prev, latitude: value }));
        }
        break;
      case "longitude":
        err.longitude = "";
        if (value.trim() === "" || RegEx.LatLong.test(value)) {
          setState((prev) => ({ ...prev, longitude: value }));
        }
        break;
      case "cityName":
        err.city = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, city: value }));
        }
        break;
      case "stateName":
        err.state = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, state: value }));
        }
        break;
      case "countryName":
        err.country = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, country: value }));
        }
        break;
      case "streetName":
        err.streetName = "";
        if (value.trim() === "" || value.length <= 100) {
          setState((prev) => ({ ...prev, streetName: value }));
        }
        break;
      case "postalCode":
        err.postalCode = "";
        if (
          value.trim() === "" ||
          (RegEx.Numeric.test(value) && value.length <= 8)
        ) {
          setState((prev) => ({ ...prev, postalCode: value }));
        }
        break;
      case "contactNumber":
        err.contactNumber = "";
        if (
          value.trim() === "" ||
          (RegEx.Numeric.test(value) && value.length <= 10)
        ) {
          setState((prev) => ({ ...prev, contactNumber: value }));
        }
        break;
      case "email":
        err.email = "";
        if (RegEx.Email.test(value) && value.length <= 50) {
          setState((prev) => ({ ...prev, email: value }));
          err.email = "";
        } else {
          setState((prev) => ({ ...prev, email: value }));
          err.email = "Please enter valid email id";
        }

        break;

      default:
        break;
    }
    setState((prev) => ({
      ...prev,
      errors: err,
    }));
  };
  const isValid = () => {
    let isValid = true;
    try {
      let hotel = { ...state };
      let err = hotel.errors;
      err.airportCode = "";
      err.hotelCode = "";
      err.hotelName = "";
      err.streetName = "";
      err.landmark = "";
      err.city = "";
      err.state = "";
      err.country = "";
      err.latitude = "";
      err.longitude = "";
      err.postalCode = "";
      err.contactNumber = "";
      err.email = "";
      if (!mappedAirportCodes?.length) {
        isValid = false;
        err.airportCode = "Please select airport code";
      }
      if (!hotel.streetName?.trim()) {
        isValid = false;
        err.streetName = "Please enter the street name";
      }
      if (!hotel.hotelName) {
        isValid = false;
        err.hotelName = "Please enter the hotel name";
      }
      if (!hotel.hotelCode?.trim()) {
        isValid = false;
        err.hotelCode = "Please enter hotel code";
      }
      if (!hotel.streetNumber?.trim()) {
        isValid = false;
        err.streetNumber = "Please enter street number";
      }
      if (!hotel.city?.trim()) {
        isValid = false;
        err.city = "Please enter city";
      }
      if (!hotel.state?.trim()) {
        isValid = false;
        err.state = "Please enter state";
      }
      if (!hotel.country?.trim()) {
        isValid = false;
        err.country = "Please enter country";
      }
      if (!hotel.latitude?.toString()?.trim()) {
        isValid = false;
        err.latitude = "Please enter latitude";
      }
      if (!hotel.longitude?.toString()?.trim()) {
        isValid = false;
        err.longitude = "Please enter longitude";
      }
      if (!hotel.contactNumber?.trim()) {
        isValid = false;
        err.contactNumber = "Please enter contact number";
      }
      if (!hotel.email?.trim()) {
        isValid = false;
        err.email = "Please enter email id";
      }
      if (!hotel.postalCode?.trim()) {
        isValid = false;
        err.postalCode = "Please enter postal code";
      }
      hotel.errors = err;
      setState((prev) => ({
        ...prev,
        hotel,
      }));
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };
  const handleOnSaveHotel = async (e) => {
    e.preventDefault();
    try {
      if (isValid()) {
        let confirmationQuestion = `${
          props?.rowData?.code
            ? `Are you sure want to update hotel <strong>${state.hotelCode}</strong> ?`
            : `Are you sure want to add new hotel <strong>${state.hotelCode}</strong> ?`
        }`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSubmitted: true }));
        let request = {
          hotelCode: state?.hotelCode ?? "",
          hotelName: state?.hotelName ?? "",
          contactNumber: state?.contactNumber ?? "",
          email: state?.email ?? "",
          streetNumber: state?.streetNumber ?? "",
          streetName: state?.streetName ?? "",
          city: state?.city ?? "",
          state: state?.state ?? "",
          country: state?.country ?? "",
          postalCode: state?.postalCode ?? "",
          latitude: state?.latitude ?? 0,
          longitude: state?.longitude ?? 0,
          airlineCode: state?.airlineCode ?? "",
          airportCodes: mappedAirportCodes,
          userName: sessionStorage.getItem("session_userName"),
        };
        const response = await axiosPost("Hotel/save", request);
        setState((prev) => ({ ...prev, isSubmitted: false }));
        isConfirmed = await showResponseMessageWithErrorInToast(response);
        if (isConfirmed) {
          await props.onRefresh();
          await props.onClose();
        }
      }
    } catch (err) {
      console.log(err);
      setState((prev) => ({ ...prev, isSubmitted: false }));
    }
  };

  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "50%" } }}
        onAfterOpen={async () => {
          await fetchApiOnPageLoad();
        }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {props?.isView
              ? "View Hotel"
              : state?.hotelCode
              ? "Update Hotel"
              : "Add Hotel"}
          </h6>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Hotel Code <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="hotelCode"
                  title="hotelCode"
                  readOnly={state?.hotelCode || props?.isView}
                  placeholder="Enter hotel code"
                  value={state.hotelCode ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.hotelCode?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.hotelCode}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Hotel Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="hotelName"
                  title="hotelName"
                  placeholder="Enter hotel name"
                  readOnly={props?.isView}
                  value={state.hotelName ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.hotelName?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.hotelName}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Airport<span className="text-danger">*</span>
                </label>
                <DropDownBox
                  value={mappedAirportCodes}
                  valueExpr="airportCode"
                  displayExpr="airportCode"
                  deferRendering={false}
                  showClearButton={true}
                  readOnly={props?.isView}
                  dataSource={state.dropdownAirportDataSource}
                  onValueChanged={() => {
                    setMappedAirportCodes([]);
                    refLstAirport.current.instance.unselectAll();
                    let err = { ...state.errors, airportCode: "" };
                    setState((prev) => ({ ...prev, errors: err }));
                  }}
                  contentRender={() => {
                    return (
                      <List
                        ref={refLstAirport}
                        dataSource={
                          new DataSource({
                            store: state.dropdownAirportDataSource,
                            sort: [
                              "Position",
                              { selector: "isMapped", desc: true },
                            ],
                            sortOrder: "desc",
                            paginate: true,
                            pageSize: 10,
                          })
                        }
                        keyExpr="airportCode"
                        displayExpr="airportName"
                        searchEnabled={true}
                        searchExpr={["airportCode", "airportName"]}
                        searchMode="contains"
                        pageLoadMode="scrollBottom"
                        showSelectionControls={true}
                        selectionMode={"multiple"}
                        indicateLoading={true}
                        onSelectionChanged={() => {
                          try {
                            let err = { ...state.errors, airportCode: "" };
                            setState((prev) => ({ ...prev, errors: err }));
                            if (refLstAirport.current) {
                              setMappedAirportCodes(
                                refLstAirport?.current?.instance?.option(
                                  "selectedItemKeys"
                                ) ?? []
                              );
                            }
                          } catch (error) {
                            console.log("onSelectionChanged", error);
                          }
                        }}
                      />
                    );
                  }}
                  placeholder="Select an item"
                />
                {state.errors.airportCode.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.airportCode}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Contact Number<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="contactNumber"
                  title="contactNumber"
                  readOnly={props?.isView}
                  placeholder="Enter contact number"
                  value={state.contactNumber ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.contactNumber?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.contactNumber}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Email Id<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="email"
                  title="email"
                  readOnly={props?.isView}
                  placeholder="Enter email id"
                  value={state.email ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.email?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.email}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Street Number<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="streetNumber"
                  title="streetNumber"
                  readOnly={props?.isView}
                  placeholder="Enter street number"
                  value={state.streetNumber ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.streetNumber?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.streetNumber}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  City<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="cityName"
                  title="cityName"
                  readOnly={props?.isView}
                  placeholder="Enter City"
                  value={state.city ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.city?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.city}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  State<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="stateName"
                  title="stateName"
                  readOnly={props?.isView}
                  placeholder="Enter State"
                  value={state.state ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.state?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.state}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Country<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="countryName"
                  title="countryName"
                  readOnly={props?.isView}
                  placeholder="Enter Country"
                  value={state.country ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.country?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.country}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Postal Code<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="postalCode"
                  title="postalCode"
                  readOnly={props?.isView}
                  placeholder="Enter postal code"
                  value={state.postalCode ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.postalCode?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.postalCode}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Latitude<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="latitude"
                  title="latitude"
                  readOnly={props?.isView}
                  placeholder="Enter latitude"
                  value={state.latitude ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.latitude?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.latitude}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Longitude<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="longitude"
                  title="longitude"
                  readOnly={props?.isView}
                  placeholder="Enter longitude"
                  value={state.longitude ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.longitude?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.longitude}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div className="form-group">
                <label>Street Name</label>
                <div className="input-group mb-2">
                  <textarea
                    style={{ resize: "none" }}
                    className="form-control form-control-sm"
                    name="streetName"
                    title="streetName"
                    readOnly={props?.isView}
                    placeholder="Enter street"
                    rows={3}
                    value={state.streetName ?? ""}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  />
                  <button
                    type="button"
                    title="Search Google"
                    className="btn btn-info"
                    hidden={props?.isView}
                    onClick={() => {
                      setState((prev) => ({
                        ...prev,
                        openGooglePlaceSearchModal: true,
                      }));
                    }}
                  >
                    <i className="fab fa-google" />
                  </button>
                </div>
                {state.errors.streetName?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.streetName}
                  </span>
                )}
              </div>
            </div>
            <div
              className="col-lg-12 col-md-12"
              style={{ display: props?.isView ? "none" : "block" }}
            >
              <div
                style={{
                  height: `290px`,
                  width: `100%`,
                }}
              >
                <Map
                  defaultZoom={16}
                  //center={center}
                  // visible={!state?.hotelCode}
                  height="100%"
                  width="100%"
                  controls={true}
                  markerIconSrc="https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/maps/map-marker.png"
                  // markerIconSrc={{
                  //   url: `../assets/img/poi/red.png?v=1.0`,
                  // }}
                  markers={[
                    {
                      location: [state.latitude, state.longitude],
                      tooltip: {
                        text: state.streetName,
                      },
                    },
                  ]}
                  provider="google"
                  apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
                ></Map>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Save"
            hidden={props?.isView}
            className="btn btn-success"
            onClick={async (e) => {
              await handleOnSaveHotel(e);
            }}
          >
            <i
              className={`fas fa-${
                state.isSubmitted ? "spinner fa-spin" : "check"
              }`}
            />
            &nbsp;&nbsp;Save
          </button>
          <button
            type="button"
            className="btn btn-custom-gray "
            onClick={() => {
              props.onClose();
            }}
            title="Close"
          >
            <i className="fas fa-times"></i> Close
          </button>
        </div>
      </Modal>
      {state.openGooglePlaceSearchModal && (
        <GooglePlaceSearchComponent
          optionalAutoFillAddress={state.streetName}
          optionalAutoFillLatitude={state.latitude}
          optionalAutoFillLongitude={state.longitude}
          onChange={(data) => {
            setState((prev) => ({
              ...prev,
              streetName: data?.landmark ?? "",
              streetNumber: data?.roadArea ?? "",
              city: data?.cityName ?? "",
              state: data?.stateName ?? "",
              country: data?.countryName ?? "",
              postalCode: data?.postalCode ?? "",
              latitude: data?.latitude ?? "",
              longitude: data?.longitude ?? "",
              errors: {
                ...prev.errors,
                streetName: "",
                streetNumber: "",
                city: "",
                state: "",
                country: "",
                latitude: "",
                longitude: "",
                postalCode: "",
              },
            }));
          }}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              openGooglePlaceSearchModal: false,
            }));
          }}
        />
      )}
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: "#historydiv" }}
        visible={state.loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        closeOnOutsideClick={false}
      />
    </>
  );
});
